// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1rNHg","addWidgetButton":"Header_addWidgetButton__1PB3g","dashboardTabs":"Header_dashboardTabs__3upPV","active":"Header_active__3m09m"};